// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"2260e473","707":"03b9b6cb","750":"14da5926"}[chunkId] + ".chunk.js";
};